export const BASE_URL = process.env.REACT_APP_API_URL ?? 'https://api.vavschool.com/';

export const URLS = {
  LOGIN:            `${BASE_URL}api/v1/auth/login`,
  VERIFY_OTP:       `${BASE_URL}api/v1/auth/verify_otp`,
  LOGOUT:           `${BASE_URL}api/v1/auth/logout`,
  GET_ALL_TEACHERS: `${BASE_URL}api/v1/teachers/get`,
  VERIFY_PIN:     `${BASE_URL}api/v1/attendance/teacher/verify_pin`,
  MARK_ATTENDANCE:  `${BASE_URL}api/v1/attendance/teacher/self_mark`,
  GET_ATTENDANCE: (params?: { teacher_id?: string | number; date?: string; status?: string }) => {
    const url = new URL(`${BASE_URL}api/v1/attendance/teacher/list`);
    if (params?.teacher_id != null) url.searchParams.set('teacher_id', String(params.teacher_id));
    if (params?.date)               url.searchParams.set('date', params.date);
    if (params?.status)             url.searchParams.set('status', params.status);
    return url.toString();
  },
};
